/**
 * Figma MCP `get_design_context` — node 1:4989 (“What Matter to Me”) KPI grid.
 * Typography, colors, gaps, and asset URLs match MCP output (no guessed values).
 */
/** MCP asset URLs (localhost Figma desktop server). */
export const WMTM_ASSETS = {
    toolbarChevron: "http://localhost:3845/assets/f10ee0613c4f90f18c52073ff9ad307ed60143b8.svg",
    footerArrow: "http://localhost:3845/assets/17efeaabd751892b49a33439dab6bef81437c12d.svg",
    imgGradient: "http://localhost:3845/assets/2b9949ad7cb6d7841b36b6c47f05a703549cf721.svg",
    icons: {
        /** imgContainer */
        a: "http://localhost:3845/assets/da2bca483fd63349cf7a0d8c38688da39aee34f1.svg",
        /** imgContainer1 */
        b: "http://localhost:3845/assets/841e4593460cf5b97131535a03a717d0dba1f15b.svg",
        /** imgContainer2 */
        c: "http://localhost:3845/assets/20b953e0844dd4956ca9340c59e0a46cea0cf4b6.svg",
        /** imgContainer3 */
        d: "http://localhost:3845/assets/eeabf5a4857e86cc690e5ab1f7efbdf504664cfc.svg",
        /** imgContainer4 */
        e: "http://localhost:3845/assets/3b7f998eece3f1f348c4a196bec70080be642768.svg",
        /** imgContainer5 */
        f: "http://localhost:3845/assets/f9b1b6ae371f0aa3f68a33054943bbda3d6c21e6.svg",
        /** imgContainer6 */
        g: "http://localhost:3845/assets/6818407e1701a81fae5cde997ffc94684a433fe9.svg",
        /** imgContainer7 */
        h: "http://localhost:3845/assets/21d8ee86ca06f2b595c153bafc399419c4b6f26f.svg",
        /** imgContainer8 */
        i: "http://localhost:3845/assets/e7d27d8aefcbf230316324315e60134dadfb8035.svg",
    },
};
const C = {
    g1: "#15803D",
    g2: "#4ade80",
    o: "#fb923c",
    r: "#dc2626",
    gy: "#c3c3c3",
};
export const WMTM_KPI_ROWS = [
    [
        {
            nodeId: "1:5003",
            title: "Operating Income",
            titleTone: "white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.a,
            iconW: 13.5,
            iconH: 13.5,
            variant: "glass",
            metricsGap: 12,
            metrics: [
                { dotColor: C.g1, label: "1" },
                { dotColor: C.g2, label: "2" },
                { dotColor: C.o, label: "3" },
                { dotColor: C.r, label: "4" },
                { dotColor: C.gy, label: "5" },
            ],
        },
        {
            nodeId: "1:5031",
            title: "Gross Margin",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.b,
            iconW: 16.125,
            iconH: 12,
            variant: "glass-orange-overlay",
            metricsGap: 12,
            overflowClip: true,
            metrics: [
                { dotColor: C.g1, label: "1" },
                { dotColor: C.g2, label: "2" },
                { dotColor: C.o, label: "3" },
                { dotColor: C.r, label: "4" },
                { dotColor: C.gy, label: "5" },
            ],
        },
        {
            nodeId: "1:5060",
            title: "EBITDA",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.c,
            iconW: 12,
            iconH: 12,
            variant: "glass-img-overlay",
            metricsGap: 12,
            overflowClip: true,
            metrics: [
                { dotColor: C.g1, label: "1" },
                { dotColor: C.g2, label: "2" },
                { dotColor: C.o, label: "3" },
                { dotColor: C.r, label: "4" },
                { dotColor: C.gy, label: "5" },
            ],
        },
    ],
    [
        {
            nodeId: "1:5090",
            title: "Marketing KPIs",
            titleTone: "white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.a,
            iconW: 13.5,
            iconH: 13.5,
            variant: "tint-red",
            metricsGap: 12,
            metrics: [
                { dotColor: C.g1, label: "1" },
                { dotColor: C.g2, label: "2" },
                { dotColor: C.o, label: "3" },
                { dotColor: C.r, label: "4" },
                { dotColor: C.gy, label: "5" },
            ],
        },
        {
            nodeId: "1:5118",
            title: "Debt to Equity",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.d,
            iconW: 13.5,
            iconH: 13.5,
            variant: "tint-orange",
            metricsGap: 12,
            metrics: [
                { dotColor: C.g1, label: "1" },
                { dotColor: C.g2, label: "2" },
                { dotColor: C.o, label: "3" },
                { dotColor: C.r, label: "4" },
                { dotColor: C.gy, label: "5" },
            ],
        },
        {
            nodeId: "1:5146",
            title: "Inventory Alerts",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.e,
            iconW: 13.5,
            iconH: 13.5,
            variant: "tint-green",
            metricsGap: 12,
            metrics: [
                { dotColor: C.g1, label: "1" },
                { dotColor: C.g2, label: "2" },
                { dotColor: C.o, label: "3" },
                { dotColor: C.r, label: "4" },
                { dotColor: C.gy, label: "5" },
            ],
        },
    ],
    [
        {
            nodeId: "1:5178",
            title: "Sales Metrics",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.f,
            iconW: 13.5,
            iconH: 13.5,
            variant: "glass",
            metricsGap: 10,
            metrics: [
                { dotColor: C.g1, label: "15" },
                { dotColor: C.g2, label: "25" },
                { dotColor: C.o, label: "35" },
                { dotColor: C.r, label: "45" },
                { dotColor: C.gy, label: "55" },
            ],
        },
        {
            nodeId: "1:5206",
            title: "Conversion Rates",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.f,
            iconW: 13.5,
            iconH: 13.5,
            variant: "glass",
            metricsGap: 10,
            metrics: [
                { dotColor: C.g1, label: "15" },
                { dotColor: C.g2, label: "25" },
                { dotColor: C.o, label: "35" },
                { dotColor: C.r, label: "45" },
                { dotColor: C.gy, label: "55" },
            ],
        },
        {
            nodeId: "1:5234",
            title: "User Engagement",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.g,
            iconW: 15,
            iconH: 14.25,
            variant: "glass",
            metricsGap: 12,
            metrics: [
                { dotColor: C.g1, label: "5" },
                { dotColor: C.g2, label: "10" },
                { dotColor: C.o, label: "15" },
                { dotColor: C.r, label: "20" },
                { dotColor: C.gy, label: "25" },
            ],
        },
    ],
    [
        {
            nodeId: "1:5263",
            title: "Customer Satisfaction",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.h,
            iconW: 15,
            iconH: 12,
            variant: "glass",
            metricsGap: 10,
            metrics: [
                { dotColor: C.g1, label: "15" },
                { dotColor: C.g2, label: "25" },
                { dotColor: C.o, label: "35" },
                { dotColor: C.r, label: "45" },
                { dotColor: C.gy, label: "55" },
            ],
        },
        {
            nodeId: "1:5291",
            title: "Lead Generation",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.f,
            iconW: 13.5,
            iconH: 13.5,
            variant: "glass",
            metricsGap: 12,
            metrics: [
                { dotColor: C.g1, label: "5" },
                { dotColor: C.g2, label: "10" },
                { dotColor: C.o, label: "15" },
                { dotColor: C.r, label: "20" },
                { dotColor: C.gy, label: "25" },
            ],
        },
        {
            nodeId: "1:5319",
            title: "Churn Rate",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.i,
            iconW: 13.5,
            iconH: 13.5,
            variant: "glass",
            metricsGap: 12,
            metrics: [
                { dotColor: C.g1, label: "2" },
                { dotColor: C.g2, label: "4" },
                { dotColor: C.o, label: "6" },
                { dotColor: C.r, label: "8" },
                { dotColor: C.gy, label: "10" },
            ],
        },
    ],
    [
        {
            nodeId: "1:5348",
            title: "Product Returns",
            titleTone: "muted-white",
            titleFont: "inter",
            iconSrc: WMTM_ASSETS.icons.h,
            iconW: 15,
            iconH: 12,
            variant: "glass",
            metricsGap: 12,
            metrics: [
                { dotColor: C.g1, label: "3" },
                { dotColor: C.g2, label: "6" },
                { dotColor: C.o, label: "9" },
                { dotColor: C.r, label: "12" },
                { dotColor: C.gy, label: "15" },
            ],
        },
        {
            nodeId: "1:5376",
            title: "Market Share",
            titleTone: "muted-white",
            titleFont: "inter",
            iconSrc: WMTM_ASSETS.icons.f,
            iconW: 13.5,
            iconH: 13.5,
            variant: "glass",
            metricsGap: 10,
            metrics: [
                { dotColor: C.g1, label: "10" },
                { dotColor: C.g2, label: "20" },
                { dotColor: C.o, label: "30" },
                { dotColor: C.r, label: "40" },
                { dotColor: C.gy, label: "50" },
            ],
        },
        {
            nodeId: "1:5404",
            title: "New Customers",
            titleTone: "muted-white",
            titleFont: "montserrat",
            iconSrc: WMTM_ASSETS.icons.i,
            iconW: 13.5,
            iconH: 13.5,
            variant: "glass-highlight",
            metricsGap: 12,
            metrics: [
                { dotColor: C.g1, label: "10" },
                { dotColor: C.g2, label: "20" },
                { dotColor: C.o, label: "30" },
                { dotColor: C.r, label: "40" },
            ],
        },
    ],
];
